import { IGameProvider } from "@base/features/game/model/interfaces";
import { container } from "tsyringe";

export default function GinRummyOption(props: {children: JSX.Element}) {
  const gameProvider: IGameProvider = container.resolve('gameProvider');
  return (gameProvider.GAME_ID === 3) ? props.children : null;
}
